<div class="checkboxInput">
  <input
    type="checkbox"
    [id]="id"
    [name]="id"
    [(ngModel)]="value"
    [required]="isRequired"
    [ngClass]="{ error: hasError }"
    [attr.aria.invalid]="errorText.length > 0"
    [attr.aria-describedBy]="errorId"
    (blur)="markAsTouched()"
  />
  <label [for]="id">
    <span *ngIf="hasDictionaryLabel" class="title">
      {{ labelKey | i18next }}
    </span>
    <span *ngIf="!hasDictionaryLabel" class="title">
      <ng-content></ng-content>
    </span>
    <span *ngIf="htmlLabel" class="title" [innerHTML]="htmlLabel"></span>
  </label>
</div>
<span class="app-error-text" [id]="errorId">
  {{ errorText ? (errorText | i18next) : '' }}
</span>
